import { Icon } from "@chakra-ui/react";
import React from "react";
export function ArrowUpLine(props) {
  return <Icon width="18" height="18" viewBox="0 0 18 18" {...props} data-sentry-element="Icon" data-sentry-component="ArrowUpLine" data-sentry-source-file="ArrowUpLine.tsx">
      <path d="M8.25 5.871L4.227 9.894L3.1665 8.8335L9 3L14.8335 8.8335L13.773 9.894L9.75 5.871V15H8.25V5.871Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="ArrowUpLine.tsx" />
    </Icon>;
}